import AnimatedTitle from "../../AnimatedTitle/AnimatedTitle";
import Container from "../../Container/Container";
import styles from "./Philosophy.module.css";
import { useRef } from "react";
import { motion, useInView } from "framer-motion";

const Philosophy = () => {
  const ref = useRef(null)
  const isInView = useInView(ref, { once: true, amount: 0.3 })

  return (
    <section id="philosophy" className={styles.philosophy}>
      <Container>
        <div className={styles.inner}>
          <div className={styles.wrapHeadingPhilosophy}>
            <div className={styles.iconTitle}>
              <img
                src="/images/director-chair.svg"
                alt=""
                className={styles.chairIcon}
                width={142}
                height={176}
                loading="lazy"
              />
              <AnimatedTitle
                as="h2"
                text={['Ти — режисер', ' свого життя']}
                className={styles.title}
              />
            </div>
            <div className={styles.wrapBadge}>
              <div className={styles.badges}>
                <span className={styles.badge}>Є тільки</span>
                <div className={styles.wrapMiniBadge}>
                  <span className={styles.badgeActive}>ти</span>
                  <span className={styles.badgeActive}>твій ритм</span>
                </div>
              </div>
              <div className={styles.badgeGrean}>і момент справжньої присутності</div>
            </div>
          </div>
          <div className={styles.wrapMainIllustration}>
            <div className={styles.illustrationWrap}>
              <picture>
                <source type="image/webp" srcSet="/images/philosophy-illustration.webp" />
                <img
                  src="/images/philosophy-illustration.jpg"
                  alt=""
                  className={styles.illustration}
                  width={7334}
                  height={2771}
                  loading="lazy"
                  decoding="async"
                />
              </picture>

              <motion.div
                ref={ref}
                className={styles.gridCards}
                initial={{
                  opacity: 0,
                  scale: 0.5,
                  rotate: 20,
                  x: "-30%",
                  y: "50%",
                }}
                animate={
                  isInView
                    ? { opacity: 1, scale: 1, rotate: 0, x: "0%", y: "0%" }
                    : {}
                }
                transition={{ duration: 0.8, delay: 0.3, ease: 'easeOut' }}
              >
                <div className={styles.card}>
                  <div className={styles.wrapCartIcon}>
                    <span className={styles.cardSmallIcon}>
                      <img src="/images/memo-icon.svg" alt="i" width={6} height={10} loading="lazy" />
                    </span>
                    <span className={styles.cardSmallText}>
                      пам'ятка сітерс
                    </span>
                  </div>
                  <div className={styles.cardMain}>
                    <AnimatedTitle
                      as="p"
                      text={[
                        'Для нас кава',
                        [{ text: ' — це не ', className: styles.green }],
                        [{ text: 'просто напій', className: styles.green }],
                      ]}
                      className={styles.cardMainTitle}
                    />
                  </div>
                </div>
                <div className={styles.card}>
                  <div className={styles.cardHeader}>
                    <span className={styles.cardIcon}>
                      <img src="/images/pause-icon.svg" alt="" width={60} height={54} loading="lazy" />
                    </span>
                    <span className={styles.cardTitle}>
                      Це кнопка паузи, яка заряджає
                    </span>
                  </div>
                  <div className={styles.cardText}>
                    Ми віримо, що в шаленому ритмі життя дуже важливо знайти
                    момент для себе.
                    <br />
                    Момент, коли проста чашка кави стане твоїм особистим
                    ритуалом повернення до
                    себе.
                  </div>
                </div>
              </motion.div>
            </div>
            <motion.div
              ref={ref}
              className={styles.badgePhi}
              initial={{ opacity: 0, scale: 0.5, rotate: 90, y: "-50%" }}
              animate={
                isInView ? { opacity: 1, scale: 1, rotate: 0, y: "-50%" } : {}
              }
              transition={{ duration: 0.8, delay: 0.3, ease: 'easeOut' }}
            >
              <img
                className={styles.logoBadgePhi}
                src="/images/logoBadgePhi.svg"
                alt=""
                width={44}
                height={48}
                loading="lazy"
              />
              <img
                className={styles.circleTextBadgePhi}
                src="/images/circleTextBadgePhi.svg"
                alt=""
                width={163}
                height={163}
                loading="lazy"
              />
            </motion.div>
          </div>
        </div>
      </Container>
    </section>
  )
}

export default Philosophy
